import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getToken } from '../../api';
import { TOTAL_ONBOARDING_STEPS } from './constants';

export default function PathSelection() {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(null);

  if (!getToken()) { navigate('/login'); return null; }

  return (
    <div className="auth-screen" style={{ paddingTop: 80 }}>
      <div className="step-indicator">4 of {TOTAL_ONBOARDING_STEPS}</div>
      <div className="display-md" style={{ marginBottom: 52 }}>
        How do you want to find your person?
      </div>

      <div
        className="path-option"
        onMouseEnter={() => setHovered('quick')}
        onMouseLeave={() => setHovered(null)}
        onClick={() => navigate('/onboarding/quick')}
      >
        <div>
          <div className="path-option-title">Quick Match</div>
          <div className="path-option-sub">
            2 minutes. Get your first matches today. Your algorithm learns as you go.
          </div>
        </div>
        <div className={`path-dot${hovered === 'quick' ? ' visible' : ''}`} />
      </div>

      <div
        className="path-option"
        onMouseEnter={() => setHovered('deep')}
        onMouseLeave={() => setHovered(null)}
        onClick={() => navigate('/onboarding/quick', { state: { continueToDeep: true } })}
      >
        <div>
          <div className="path-option-title">
            Deep Search
            <span className="path-beta-tag">BETA</span>
          </div>
          <div className="path-option-sub">
            10 minutes. Answer everything now. Your first matches will be your best.
          </div>
        </div>
        <div className={`path-dot${hovered === 'deep' ? ' visible' : ''}`} />
      </div>
    </div>
  );
}
